export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// /~/react-router/es/PromiseUtils.js
// module id = 479
// module chunks = 31